import { render, staticRenderFns } from "./AS2.vue?vue&type=template&id=6a1cb1ab&"
import script from "./AS2.vue?vue&type=script&lang=js&"
export * from "./AS2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports